import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Aileron, sans-serif",
  },
  palette: {
    primary: {
      main: "#511FFF",
    },
  },
});

export default theme;
